export function processingEmailBlock(content: TContent): TContent {
  return {
    ...content,
    parser_type: 'html_parser',
  };
}
